///mastercompanyusagestats/list
export const GET_MASTER_COMPANY_USAGE_STATS = "GET_MASTER_COMPANY_USAGE_STATS";
export const GET_MASTER_COMPANY_USAGE_STATS_SUCCESS =
  "GET_MASTER_COMPANY_USAGE_STATS_SUCCESS";
export const GET_MASTER_COMPANY_USAGE_STATS_FAILED =
  "GET_MASTER_COMPANY_USAGE_STATS_FAILED";

///mastercompanyusagestats/data/812 (By ID)
export const GET_MASTER_COMPANY_USAGE_STATS_BY_ID =
  "GET_MASTER_COMPANY_USAGE_STATS_BY_ID";
export const GET_MASTER_COMPANY_USAGE_STATS_BY_ID_SUCCESS =
  "GET_MASTER_COMPANY_USAGE_STATS_BY_ID_SUCCESS";
export const GET_MASTER_COMPANY_USAGE_STATS_BY_ID_FAILED =
  "GET_MASTER_COMPANY_USAGE_STATS_BY_ID_FAILED";

///company/list
export const GET_COMPANY_LIST = "GET_COMPANY_LIST";
export const GET_COMPANY_LIST_SUCCESS = "GET_COMPANY_LIST_SUCCESS";
export const GET_COMPANY_LIST_FAILED = "GET_COMPANY_LIST_FAILED";

///company/data/1 (By ID)
export const GET_COMPANY_BY_ID = "GET_COMPANY_BY_ID";
export const GET_COMPANY_BY_ID_SUCCESS = "GET_COMPANY_BY_ID_SUCCESS";
export const GET_COMPANY_BY_ID_FAILED = "GET_COMPANY_BY_ID_FAILED";

///companyrecentactivity/list/company/
export const GET_COMPANY_RECENT_ACTIVITY_LIST =
  "GET_COMPANY_RECENT_ACTIVITY_LIST";
export const GET_COMPANY_RECENT_ACTIVITY_LIST_SUCCESS =
  "GET_COMPANY_RECENT_ACTIVITY_LIST_SUCCESS";
export const GET_COMPANY_RECENT_ACTIVITY_LIST_FAILED =
  "GET_COMPANY_RECENT_ACTIVITY_LIST_FAILED";

///masterinvoice/search
export const MASTER_INVOICE_SEARCH = "MASTER_INVOICE_SEARCH";
export const MASTER_INVOICE_SEARCH_SUCCESS = "MASTER_INVOICE_SEARCH_SUCCESS";
export const MASTER_INVOICE_SEARCH_FAILED = "MASTER_INVOICE_SEARCH_FAILED";

///masterinvoice/pdf/
export const MASTER_INVOICE_PDF = "MASTER_INVOICE_PDF";
export const MASTER_INVOICE_PDF_SUCCESS = "MASTER_INVOICE_PDF_SUCCESS";
export const MASTER_INVOICE_PDF_FAILED = "MASTER_INVOICE_PDF_FAILED";

///mastersystemerrorlog/list
export const MASTER_SYSTEM_ERROR_LOG_LIST = "MASTER_SYSTEM_ERROR_LOG_LIST";
export const MASTER_SYSTEM_ERROR_LOG_LIST_SUCCESS =
  "MASTER_SYSTEM_ERROR_LOG_LIST_SUCCESS";
export const MASTER_SYSTEM_ERROR_LOG_LIST_FAILED =
  "MASTER_SYSTEM_ERROR_LOG_LIST_FAILED";

///mastersystemerrorlog/data/
export const MASTER_SYSTEM_ERROR_LOG_DATA = "MASTER_SYSTEM_ERROR_LOG_DATA";
export const MASTER_SYSTEM_ERROR_LOG_DATA_SUCCESS =
  "MASTER_SYSTEM_ERROR_LOG_DATA_SUCCESS";
export const MASTER_SYSTEM_ERROR_LOG_DATA_FAILED =
  "MASTER_SYSTEM_ERROR_LOG_DATA_FAILED";

///mastersystemerrorlog/search
export const MASTER_SYSTEM_ERROR_LOG_SEARCH = "MASTER_SYSTEM_ERROR_LOG_SEARCH";
export const MASTER_SYSTEM_ERROR_LOG_SEARCH_SUCCESS =
  "MASTER_SYSTEM_ERROR_LOG_SEARCH_SUCCESS";
export const MASTER_SYSTEM_ERROR_LOG_SEARCH_FAILED =
  "MASTER_SYSTEM_ERROR_LOG_SEARCH_FAILED";

///masteruser/list
export const GET_MASTER_USER_LIST = "GET_MASTER_USER_LIST";
export const GET_MASTER_USER_LIST_SUCCESS = "GET_MASTER_USER_LIST_SUCCESS";
export const GET_MASTER_USER_LIST_FAILED = "GET_MASTER_USER_LIST_FAILED";

///masterrecentactivity/list/user
export const GET_MASTER_RECENT_ACTIVITY_LIST =
  "GET_MASTER_RECENT_ACTIVITY_LIST";
export const GET_MASTER_RECENT_ACTIVITY_LIST_SUCCESS =
  "GET_MASTER_RECENT_ACTIVITY_LIST_SUCCESS";
export const GET_MASTER_RECENT_ACTIVITY_LIST_FAILED =
  "GET_MASTER_RECENT_ACTIVITY_LIST_FAILED";
